/** @type {Map<string, import('./documentPreviewTypes.js').ArtifactSelection>} */
const artifactPayloads = new Map()

/** @param {import('./documentPreviewTypes.js').ArtifactSelection} artifact */
export function registerArtifactPayload(artifact) {
  artifactPayloads.set(artifact.artifactId, artifact)
  return artifact
}

/** @param {string} artifactId */
export function getArtifactPayload(artifactId) {
  return artifactPayloads.get(artifactId) ?? null
}

export function clearArtifactPayloadsForTests() {
  artifactPayloads.clear()
}
